<template lang="">
    <div class="sc-btn" @click="s()">
        <div class="sc-btn-inner">
            <div v-if="icon" class="btn-icon">
                <img :src="icon">
            </div>
            <div v-if="$slots.default" class="btn-label">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ScButton',
    components: {},
    props:['scto', 'icon'],
    setup(props) {
        const s = () => {
            if(!props['scto']){
                return
            }
            let e = document.getElementById(props['scto'])
            if(!e){
                return
            }
            e.scrollIntoView({behavior: 'smooth'})
        }
        const icon = props['icon']
        return {s, icon}
    },
}
</script>

<style>
    .sc-btn{
        font-size: 1.1em;
        padding: 0.8em 1em;
        border: solid 0.15em #FFFFFF;
        border-radius: 1em;
        background: #0c0c0c;
        font-weight: 800;
        filter: drop-shadow(0px 0px 0.2em #FFFFFF50);
        box-shadow: inset 0px 0px 0.3em #FFFFFF50;
        cursor: pointer;
        transition: box-shadow 300ms;
        width: fit-content;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .sc-btn-inner{
        display: flex;
        flex-direction: row;
        flex-wrap: no-wrap;
        align-content: center;
        align-items: center;
    }

    .sc-btn:hover{
        box-shadow: inset 0px 0px 0.6em #FFFFFF60;
    }

    .sc-btn div {
        transition: filter 300ms, transform 300ms;
        filter: drop-shadow(0px 0px 0.2em #FFFFFF40);
    }
    .sc-btn:hover div {
        filter: drop-shadow(0px 0px 0.2em #FFFFFF70);
        transform: scale(1.05);
    }

    .btn-icon{
        display: inline;
        border-right-width: 0.1em;
        padding-right:0.35em;
        margin-right:0.35em;
        border-right-style: solid;
        border-image: 
        linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0),
          rgba(255, 255, 255, 0.418), 
          rgba(255, 255, 255, 0)
        ) 1 100%;
    }

    .btn-label{
        margin-bottom: 0.1em
    }

    .btn-icon img{
        width: 1.2em;
        filter: sepia(100%) saturate(0) brightness(100);
        -webkit-filter: sepia(100%) saturate(0) brightness(100);
    }
</style>